export const AUTH_KEYS = {
  COOKIES_LOGIN_CONTEXT: "UMB_BCONTEXT",
  LOCAL_STORAGE_USER: "Auth.Context",
  OLD_LOCAL_STORAGE_USER: "CURRENT_USER",
  LOCAL_STORAGE_CURRENCY: "CURRENT_CURRENCY",
};

export const SHOPPING_CART_EVENTS = {
  NOTIFY_USER_CART_CHANGED: "NotifyUserCartChanged",
  ADD_USER_CART_ITEM: "AddUserCartItem",
  CLEAR_USER_CART_ITEM: "ClearUserCartItem",
  CLEAR_USER_CART: "ClearUserCart",
};

export const HOME_PAGE_CONSTANTS = {
  GET_FEATURED_TEACHER_QUANTITY: 12,
  GET_SAMPLE_LESSON_QUANTITY: 3,
  GET_VOD_PACKAGE_QUANTITY: 12,
  GET_SPECIAL_PACKAGE_QUANTITY: 12,
};

export const GENDERS = {
  MALE: "male",
  FEMALE: "female",
  OTHER: "other",
};

export const PRE_TEST_PATH = "pre-test";

export const APP_NAME = "DOTORE";

export const LOCAL_STORAGE_OPEN_PRE_TEST_DIALOG = "open_pre_test_dialog";

export const CURRENCY = {
  USD: "USD",
  VND: "VND",
  KRW: "KRW",
};

export const CART_PAYMENT_STEP_PARAM = "step";

export const LANDING_TOPIK_ROUTE = "topik";
export const LANDING_HEADER_NAVIGATION_HREF = {
  HOMEPAGE: "/",
  RANKING_LEADERBOARD: "/ranking-leaderboard",
  REAL_TIME_LECTURES: "/real-time-lectures",
  VOD: "/vod",
  VOD_SERIES: "/vod-series",
  AI_TUTOR: "/ai-chat",
  TOPIK_TEST: "/test/topik",
  PRE_TEST: "/pretest",
  PACKAGES: "/packages",
  EVENTS: "/events",
  CLASS: "/courses",
  CUSTOMER_CENTER: "/contact-us?tab=CUSTOMER_CENTER",
  INFO_BOARD: "/contact-us?tab=INFO_BOARD",
  SHORTS: "/shorts",
};

export const ADS_DISPLAY_PAGE_ID = {
  [LANDING_HEADER_NAVIGATION_HREF.HOMEPAGE]: 1,
  [LANDING_HEADER_NAVIGATION_HREF.RANKING_LEADERBOARD]: 2,
  [LANDING_HEADER_NAVIGATION_HREF.REAL_TIME_LECTURES]: 3,
  [LANDING_HEADER_NAVIGATION_HREF.VOD]: 4,
  [LANDING_HEADER_NAVIGATION_HREF.VOD_SERIES]: 5,
  [LANDING_HEADER_NAVIGATION_HREF.AI_TUTOR]: 6,
  [LANDING_HEADER_NAVIGATION_HREF.TOPIK_TEST]: 9,
  [LANDING_HEADER_NAVIGATION_HREF.PACKAGES]: 8,
  [LANDING_HEADER_NAVIGATION_HREF.EVENTS]: 7,
  [LANDING_HEADER_NAVIGATION_HREF.CLASS]: 10,
};

export const ADS_NO_DISPLAY_PAGE_ID = "ADS_NO_DISPLAY_PAGE_ID";

export const VOD_PAGE = {
  CATEGORY: "category",
  VOD_SCROLL_POSITION: "vodScrollPosition",
  FIRST: "first",
};

export const VOD_SERIES_PAGE = {
  CATEGORY: "category",
  VOD_SCROLL_POSITION: "vodSeriesScrollPosition",
  FIRST: "first",
};

export const PACKAGES_PAGE = {
  PACKAGES_SCROLL_POSITION: "packagesScrollPosition",
  FIRST: "first",
};

export const EVENTS_PAGE = {
  CATEGORY: "category",
  EVENTS_SCROLL_POSITION: "eventsScrollPosition",
  FIRST: "first",
};

export const CLASS_PAGE = {
  CATEGORY: "category",
  FIRST: "first",
  PAGE: "page",
  ROWS: "rows",
  SEARCH: "search",
  SORT_BY: "sortBy",
  TOPIC: "topic",
  RATING: "rating",
  STATUS: "status",
  TIME_OF_DAY: "timeOfDay",
  NATIONALITY: "nationality",
  START_TUITION: "startTuition",
  END_TUITION: "endTuition",
};

export const CLASS_LIST_DEFAULT_ROWS = 12;

export const HOME_PAGE = {
  VOD_SECTION_SCROLL_POSITION: "vodSectionScrollPosition",
  PACKAGE_SECTION_SCROLL_POSITION: "packageSectionScrollPosition",
  TEACHER_SECTION_SCROLL_POSITION: "teacherSectionScrollPosition",
};

export const HEADER_INDEX = 10000;
